<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" *ngIf="fromVehicleCustomerDetails ==false" translate>
          <ng-container *ngIf="customerId === 0;else load_else " translate>
            lblAddCustomer
          </ng-container>
          <ng-template #load_else translate>
            lblEditCustomer
           </ng-template>
        </div>
        <div class="popup-title mr-auto" *ngIf="fromVehicleCustomerDetails ==true" translate>
          <ng-container translate>
            lblViewCustomer
          </ng-container>
        </div>
        <div class="float-right">
          <div class="mr-2 edit-iconlist">
            <ul class="list-inline d-flex">
              <li *ngIf="isCdssUser && customerId > 0">
                <button type="button" class="align-self-center text-white" (click)="DialCall(DialContent)" aria-label="Center Align">
                  <em class="fa fa-phone-flip font22 align-middle"></em>
                </button>
              </li>
              <li *ngIf="fromVehicleCustomerDetails == true || customerId > 0">
                <a (click)="OpenSendNotificationModel()" class="btn btn-ico mx-2" ngbTooltip="{{'lblSendNotification' | translate}}" 
                  placement="left" tooltipClass="custom-revert">
                    <img src="./../../../assets/images/bell-regular-wh.svg" width="30" alt="" />
                </a>
              </li>
              <li>
                <a class="close mr-2" (click)="OnClose()" translate>
                  <span class="" aria-hidden="true">&times;</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between bg-grey">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">
          <li *ngFor="let tab of tabs | slice:0:noOfTabLimit; let i=index" class="nav-item" >
            <a translate class="nav-link" (click)="tabSelected(tab.id)"  [ngClass]="{'active': (selectedtab===tab.id),'disabled': (selectedtab!==tab.id && this.service.IsCustomerAddFromVehicle)}">{{tab.label}}</a>
          </li>
        </ul>
        <div class="fs-16px mr-4" *ngIf="customerId != 0">
          <ng-cotainer class="clrBlue semibold text-capitalize">
            <em class="fas fa-user mr-2"></em> 
          
            <ng-container *ngIf="firstName?.length > 0; else loadDefault">
              {{firstName}}  {{lastName}}
          </ng-container>
          <ng-template #loadDefault>
              {{customerName}}
          </ng-template>
          
          </ng-cotainer>
          <ng-cotainer class="mbold" *ngIf="customerNo != ''">&nbsp;&nbsp;-&nbsp;&nbsp;#{{customerNo}}</ng-cotainer>
        </div>
      </div>
      <ng-cotainer *ngIf="selectedtab===1">
        <app-customer-details [customerDetailsFromWidget]="customerDetails" [fromVehicleScreen]="fromVehicleScreen" [isFromServiceAdvisor]="isFromServiceAdvisor" [preferredDealerId]="preferredDealerId" [fromVehicleCustomerDetails]="fromVehicleCustomerDetails" (showVehileAndOtherDetailsTabs)="showVehileAndOtherDetailsTabsFn($event)"></app-customer-details>
      </ng-cotainer>
      <ng-cotainer *ngIf="selectedtab===2">
        <app-vehicle-list (backToFirstTab)="backToFirstTab()"></app-vehicle-list>
      </ng-cotainer>
      <ng-cotainer *ngIf="selectedtab===3">
        <app-customer-communication [customerDetail]="customerDetails"></app-customer-communication>
      </ng-cotainer>
      <ng-cotainer *ngIf="selectedtab===4">
        <app-customer-call-history [customerDetail]="customerDetails"></app-customer-call-history>
      </ng-cotainer>
      <ng-cotainer *ngIf="selectedtab===5">
        <app-customer-history [customerDetail]="customerDetails"></app-customer-history>
      </ng-cotainer>
    </div>
  </div>
</div>
<!-- Click to dial number popup -->
<ng-template #DialContent let-modal>
  <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" translate>lblCall</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)"><span aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive">
      <form class="form" #dialForm="ngForm" class="row">
        <div class="col-12 af-form-group">
          <input class="form-control" name="dialNumber" (keyup.enter)="InitiateCall(modal)" [(ngModel)]="dialNumber" placeholder="{{ 'lblDestinationNumber' | translate }}" required />
          <div *ngIf="(dialForm.touched || dialForm.submitted) && !dialForm.form.valid" class="help-block text-danger">
            <em class="fa fa-exclamation-circle" aria-hidden="true"></em>
            <span translate>lblDestinationNoRequired</span>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary mr-sm-2 btn-md" (click)="InitiateCall(modal)" translate>lblCall</button>
      <button type="button" class="btn btn-secondary btn-md" (click)="modal.dismiss(false)" translate>lblCancel</button>
    </div>
</ng-template>